import script from "./OtherServicesDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./OtherServicesDetail.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__